import script from "./ViewLiveTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewLiveTemplate.vue?vue&type=script&setup=true&lang=js"

import "./ViewLiveTemplate.vue?vue&type=style&index=0&id=0d846b39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d846b39"]])

export default __exports__